import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import '../floating-vue.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(FloatingVue, {
    themes: {
      legacy: { $extend: 'tooltip' },
      redesign: { $extend: 'tooltip' },
    },
  })
})
